export enum EmailType {
  work = 'work',
  home = 'home',
  mobile = 'mobile',
  other = 'other',
}
